import React from "react";
import TextField from "@mui/material/TextField";
import {
    FormControl,
    FormLabel,
    FormControlLabel,
    Radio,
    Checkbox,
} from "@mui/material";

interface FeedbackFormProps {
    state: {
        anonymous: boolean;
        name: string;
        email: string;
        overallExperience: string;
        presentation: string;
        games: string;
        newFriends: string;
        food: string;
        likedMost: string;
        likedMostOther: string;
        improvement: string;
    };
    handleFieldChange: (field: string, value: any) => void;
}

export const FeedbackForm: React.FC<FeedbackFormProps> = ({
    state,
    handleFieldChange,
}) => {
    const renderRadioGroup = (
        field: string,
        label: string,
        options: string[],
    ) => {
        return (
            <FormControl component="fieldset">
                <FormLabel className="mb-2" focused={false}>
                    {label}
                </FormLabel>
                <div className="grid grid-col-5 gap-y-2 xl:grid-cols-5 xl:gap-x-4">
                    {options.map((option) => (
                        <FormControlLabel
                            key={option}
                            value={option}
                            control={
                                <Radio
                                    sx={{
                                        '&.Mui-checked': {
                                            color: "#D07D14",
                                        },
                                    }}
                                />
                            }
                            label={option}
                            className="items-center"
                            checked={state[field as keyof typeof state] === option}
                            onChange={(e) =>
                                handleFieldChange(field, (e.target as HTMLInputElement).value)
                            }
                            sx={{ color: "text.secondary" }}
                        />
                    ))}
                </div>
            </FormControl>
        );
    };

    return (
        <form className="checkout-form flex flex-col gap-6">
            <FormControlLabel
                control={<Checkbox checked={state.anonymous} onChange={(e) => handleFieldChange("anonymous", (e.target as HTMLInputElement).checked)} />}
                label="Submit as Anonymous"
            />

            {!state.anonymous && (
                <>
                    <TextField
                        label="Name*"
                        value={state.name}
                        onChange={(e) => handleFieldChange("name", e.target.value)}
                        fullWidth
                    />

                    <TextField
                        label="Email*"
                        value={state.email}
                        onChange={(e) => handleFieldChange("email", e.target.value)}
                        fullWidth
                    />
                </>
            )}

            {renderRadioGroup(
                "overallExperience",
                "How was your overall experience?*",
                ["5 (Excellent)", "4", "3 (Average)", "2", "1 (Poor)"]
            )}

            {renderRadioGroup(
                "presentation",
                "How was the presentation?*",
                ["5 (Very Useful)", "4", "3 (Average)", "2", "1 (Not Useful at All)"]
            )}

            {renderRadioGroup(
                "games",
                "How were the games?*",
                ["Loved it", "Did not like it"]
            )}

            {renderRadioGroup(
                "newFriends",
                "Did you find new friends?*",
                ["Yes", "No"]
            )}

            {renderRadioGroup(
                "food",
                "How was the food from us?*",
                ["5 (Delicious)", "4", "3 (Average)", "2", "1 (Not Good at All)"]
            )}

            {renderRadioGroup(
                "likedMost",
                "What did you like most?*",
                ["Presentation", "Food", "Games", "Others"]
            )}

            {state.likedMost === "Others" && (
                <TextField
                    label="Please specify"
                    value={state.likedMostOther}
                    onChange={(e) => handleFieldChange("likedMostOther", e.target.value)}
                    fullWidth
                />
            )}

            <TextField
                label="Comments for improvement*"
                value={state.improvement}
                onChange={(e) => handleFieldChange("improvement", e.target.value)}
                multiline
                rows={3}
                fullWidth
            />
        </form>
    );
};
